<template>
<ul :class="'nav nav-' + gradient">
  <li v-for="(item, index) in navItems" :key="index">
    <a v-if="item.type === 'external'" :href="item.url" target="_blank">
      <i :class="item.icon"></i>
      <p>{{$t('sidebar_nav.'+item.label_key)}}</p>
    </a>
    <router-link v-else :to="item.path">
      <i :class="item.icon"></i>
      <p>{{$t('sidebar_nav.'+item.label_key)}}</p>
    </router-link>
  </li>
  <li v-if="hasLogout" class="active-pro">
    <a href="#" @click="logOut()">
      <i class="material-icons">exit_to_app</i>
      <p>{{$t('sidebar_nav.logout')}}</p>
    </a>
  </li>
</ul>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'nav-list',
  props: {
    navItems: {
      type: Array,
      required: true,
      validator: function(navItems) {
        return !navItems.some(
          // TODO: temporary remove the check on icon to allow material and fontello together
          item => item === null || typeof item !== 'object' || !item.path || !item.label_key // || !item.icon
        )
      }
    },
    gradient: {
      type: String,
      default: 'gradient-donapp'
    },
    hasLogout: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    logOut() {
      this.logout()
      this.goTo({ path: '/' })
    },
    ...mapMutations({
      logout: 'logout',
      goTo: 'goTo'
    })
  },
  model: {
    prop: 'value',
    event: 'updateValue'
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.nav,
.nav {
  padding-top: 14px;
  margin-top: 0px;
}

.nav li {
  margin-bottom: 6px;
}

.nav li > a,
.nav li > a {
  margin: 0px $primaryDistance 6px;
  @include borderRadius();
  color: #3c4858;
}

.nav > li > a {
  position: relative;
  display: block;
  padding: $primaryDistance;
}

.nav li a p {
  @include normalFontSize();
  font-weight: 400;
  color: $grey;
  margin-top: 1px;
  line-height: 14px;
}

.nav li a i {
  color: $grey;
  line-height: 16px;
  width: auto;
  @include bigFontSize();
}

.nav i,
.nav i {
  @include bigFontSize();
  float: left;
  margin-right: $primaryDistance;
  text-align: center;
  color: #a9afbb;
}

.nav.nav-gradient-merchant li a.router-link-active,
.nav.nav-gradient-merchant li a.router-link-active {
  @include merchantGradient();
}

.nav.nav-gradient-user li a.router-link-active,
.nav.nav-gradient-user li a.router-link-active {
  @include userGradient();
}

.nav.nav-gradient-npo li a.router-link-active,
.nav.nav-gradient-npo li a.router-link-active {
  @include npoGradient();
}

.nav.nav-gradient-donapp li a.router-link-active,
.nav.nav-gradient-donapp li a.router-link-active {
  @include donappGradient();
}

.nav li > a.router-link-active > p,
.nav li > a.router-link-active > p {
  color: $white !important;
}

.nav li > a.router-link-active > i,
.nav li > a.router-link-active > i {
  color: $white !important;
}

.nav li a.router-link-active,
.nav li a.router-link-active {
  background-color: #ffffff;
  @include shadow();
}

a .material-icons {
  vertical-align: middle;
}

.nav p,
.nav p {
  margin: 0;
}

.nav li:first-child > a,
.off-canvas-sidebar .nav li:first-child > a {
  margin: 0 15px;
}

.animation-transition-general,
.nav li > a,
.off-canvas-sidebar .nav li > a {
  -webkit-transition: all 300ms linear;
  -moz-transition: all 300ms linear;
  -o-transition: all 300ms linear;
  -ms-transition: all 300ms linear;
  transition: all 300ms linear;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/NavList.vue